import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useRole, type Caps } from '../hooks/useRole';

/** Guarda de rota por capacidade. Sem a capacidade, volta para o início do painel. */
export function RequireCap({ cap, children }: { cap: keyof Caps; children: ReactNode }) {
  const { caps, loading } = useRole();
  const { t } = useTranslation();

  if (loading) return <div className="center-note">{t('common.loading')}</div>;
  if (!caps[cap]) return <Navigate to="/app" replace />;
  return <>{children}</>;
}
